import { render, staticRenderFns } from "./createServiceAccountModal.vue?vue&type=template&id=71252646&scoped=true&"
import script from "./createServiceAccountModal.vue?vue&type=script&lang=js&"
export * from "./createServiceAccountModal.vue?vue&type=script&lang=js&"
import style0 from "./createServiceAccountModal.vue?vue&type=style&index=0&id=71252646&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71252646",
  null
  
)

export default component.exports